import { w3cwebsocket } from 'websocket'
import Bus from '@/assets/js/bus.js'
import Vue from 'vue'

/**
 * @param {*} options separate error callback
 * @example  {callback: {80400012: ()=>{}}}
 */
function enhancerMessage (options) {
  return function (event) {
    if (event.data == '2') return // heartbeat don't need deal
    const data = JSON.parse(event.data)
    const { errorCode } = data
    if (errorCode && options.callback) {
      options.callback[errorCode] && options.callback[errorCode](data)
      return
    }
    options.message(data)
  }
}
/**
 *
 * @param { String } url connect ws url
 * @param { Object } options about ws options
 * @param { websocketManage } parentObj
 * @returns { w3cwebsocket }  ws connect
 */
function createWs (url, options, parentObj) {
  let reconnectTimeout = null
  let heartbeatTimer = null
  const NewW3cwebsocket = w3cwebsocket
  const client = new NewW3cwebsocket(url)
  client.onopen = (e) => {
    const that = client
    function sendNumber () {
      if (that.readyState === that.OPEN) {
        that.send('1')
        clearTimeout(heartbeatTimer)
        heartbeatTimer = setTimeout(sendNumber, 3000)
        parentObj.consecutiveErrorCount = 0; // 成功连接后重置连续错误次数
      } else {
        // websocket error status, need to disconnect and reconnect
        that.close()
      }
    }
    sendNumber()
    // websocket重连之后的操作逻辑
    if (parentObj) {
      Bus.$emit('websocketReconnection')
    }
  }
  client.onclose =
    options.close ||
    function (e) {
      parentObj.consecutiveErrorCount++;
      // If it is not triggered manually, it needs to be reconnected
      if (parentObj.isUserClose === false && parentObj.consecutiveErrorCount < 20) {
        // parentObj.consecutiveErrorCount++
        clearTimeout(reconnectTimeout)
        reconnectTimeout = setTimeout(() => {
          parentObj.client = createWs(url, options, parentObj)
        }, 2300)
      } else if (!parentObj.isUserIgnored && parentObj.isUserClose === false) {
        Vue.prototype.$alert('The system has been disconnected due to a poor network, please click “refresh”  to reload the page.', {
          confirmButtonText: 'Refresh',
          customClass: 'reloadAlert',
          confirmButtonClass: 'reloadBtn',
          showClose: true,
          showCancelButton: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          modal: false
        }).then(() => {
          location.reload(); // 重新加载页面
        }, () => {
          parentObj.isUserIgnored = true;
        })
      }
    }
  client.onmessage = enhancerMessage(options)
  client.onerror = error => {
    if (!parentObj.isUserClose && parentObj.consecutiveErrorCount < 20) {
      clearTimeout(reconnectTimeout)
      reconnectTimeout = setTimeout(() => {
        parentObj.consecutiveErrorCount++; // 发生错误时增加连续错误次数
        parentObj.client = createWs(url, options, parentObj)
      }, 2300)
    }
  }

  return client
}
/**
 * @param { String } url create websocket url
 * @param { Object } options include (close,message,callback)  call callback when ws error
 * @example options { close?: ()=>{}, message: ()=>{}, callback => {}}
 */
class WebsocketManage {
  constructor(url, options) {
    this.$url = url
    this.$options = options
    this.isUserClose = false
    this.consecutiveErrorCount = 0 // 连续错误计数，用来确定是否需要重连
    this.isUserIgnored = false;
    if (!options.message) {
      return
    }
    this.client = createWs(this.$url, this.$options, this)
  }

  /**
   *  close websocket method
   */
  close () {
    this.isUserClose = true
    this.client.close()
  }

  /**
   * @param {Object} params send back-end message
   * @example include {type,data}, According to the back-end API
   */
  send (params) {
    this.client.send(JSON.stringify(params))
  }
}

function websocket (url, options) {
  return new WebsocketManage(url, options)
}

export default websocket
